import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    EmployeeQualificationDto, EmployeeQualificationPaginator,
    CreateEmployeeQualificationDto, QueryEmployeeQualificationDto,
    UpdateEmployeeQualificationDto
} from "../models/employee-qualification.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetEmployeeQualification(options?: QueryEmployeeQualificationDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_QUALIFICATION.GET;
    const request = (options: QueryEmployeeQualificationDto) => API.ProcessingCompanyAPI.getEmployeeQualification(options);

    const { data, isLoading, error, refetch } = useQuery<EmployeeQualificationPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetEmployeeQualificationById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_QUALIFICATION.DETAIL;
    const request = API.ProcessingCompanyAPI.getEmployeeQualificationById(id);

    const {data, isLoading, error} = useQuery<{ data:EmployeeQualificationDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateEmployeeQualification() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateEmployeeQualificationDto}) => API.ProcessingCompanyAPI.createEmployeeQualification(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_QUALIFICATION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateEmployeeQualification() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateEmployeeQualificationDto, id: number}) => API.ProcessingCompanyAPI.updateEmployeeQualification(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_QUALIFICATION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteEmployeeQualification() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deleteEmployeeQualification(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EMPLOYEE_QUALIFICATION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}